import { render, staticRenderFns } from "./gold-whatsapp.vue?vue&type=template&id=135c46f8&scoped=true"
import script from "./gold-whatsapp.vue?vue&type=script&lang=js"
export * from "./gold-whatsapp.vue?vue&type=script&lang=js"
import style0 from "./gold-whatsapp.vue?vue&type=style&index=0&id=135c46f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135c46f8",
  null
  
)

export default component.exports